/** @format */

import "./Footer.css";

export default function Footer() {
  return (
    <footer>
      <a
        href="https://github.com/Lora-Cat/weather-react-v2"
        target="_blank"
        rel="nofollow noreferrer"
        className="text-decoration-none"
      >
        Open-source code&nbsp;
      </a>
      by Valentyna Nykonchuk
    </footer>
  );
}
